import * as React from 'react'
import { Toolbar } from '@base-ui/react/toolbar'
import { twMerge } from 'tailwind-merge'

interface ActionPopoverGroupProps {
  className?: string
  children: React.ReactNode
  disabled?: boolean
}

function ActionPopoverGroup({ className, children, disabled }: ActionPopoverGroupProps) {
  return (
    <Toolbar.Group className={twMerge('flex items-center gap-1', className)} disabled={disabled}>
      {children}
    </Toolbar.Group>
  )
}

export { ActionPopoverGroup }
